// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-light-blue[data-v-15b4e613]{background-color:rgba(14,20,82,.04)}", ""]);
// Exports
module.exports = exports;
